import { createSlice } from "@reduxjs/toolkit"
import { authReducerInit, AuthState } from "./auth.types"
import { loadProfile } from "../useCases/load-profile/loadProfile.use-case"
import { logout } from "../useCases/logout/logout.use-case"
import { loginWithToken } from "../useCases/login-with-token/loginWithToken.use-case"
import { loginWithPasswordAndEmail } from "../useCases/login-with-password-and-email/loginWithPasswordAndEmail.use-case"
// import { startAppListening } from "core/src/store/store.listener"
// import { afterStoreLocationListener } from "../listener/afterNavigate.listener"

export const AUTH_FEATURE_KEY = "auth"

export const initialAuthState: AuthState = authReducerInit()

const authSlice = createSlice({
	name: AUTH_FEATURE_KEY,
	initialState: initialAuthState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(loginWithToken.pending, (state) => {
			state.loading = true
		})
		builder.addCase(loginWithToken.fulfilled, (state, action) => {
			state.awToken = action.payload.awToken
			state.awRefreshToken = action.payload.awRefreshToken
			state.isAuthenticated = true
			state.loading = false
		})
		builder.addCase(loginWithToken.rejected, (state) => {
			state.loading = false
			state.isAuthenticated = false
		})
		builder.addCase(loginWithPasswordAndEmail.pending, (state) => {
			state.loading = true
		})
		builder.addCase(loginWithPasswordAndEmail.fulfilled, (state, action) => {
			state.awToken = action.payload.awToken
			state.awRefreshToken = action.payload.awRefreshToken
			state.user = action.payload.user
			state.username = action.payload.username
			state.password = action.payload.password
			state.isAuthenticated = true
			state.loading = false
		})
		builder.addCase(loginWithPasswordAndEmail.rejected, (state) => {
			state.isAuthenticated = false
			state.loading = false
		})
		builder.addCase(loadProfile.pending, (state) => {
			state.loading = true
		})
		builder.addCase(loadProfile.fulfilled, (state, action) => {
			state.user = action.payload.user
			state.loading = false
		})
		builder.addCase(loadProfile.rejected, (state) => {
			state.loading = false
		})
		builder.addCase(logout.fulfilled, (state) => {
			state.isAuthenticated = false
			state.loading = false
			state.awToken = undefined
			state.awRefreshToken = undefined
			state.user = undefined
		})
	},
})

export const auth = authSlice.reducer

export const authActions = authSlice.actions

// startAppListening(afterStoreLocationListener);
